import { TransferBaseRequestDto } from '@api/external-transfer';

export class ImportToFusionDto extends TransferBaseRequestDto {
	public Workfile: string;

	public constructor(params: Partial<ImportToFusionDto>) {
		super({
			Environment: params.Environment
		});

		this.Workfile = params.Workfile;
	}
}
